import truncate from 'lodash/truncate';

export const truncatePerex = (perex, length = 230) =>
  truncate(perex, { length, separator: ' ', omission: '…' });



// WEBPACK FOOTER //
// ./src/utils/text.js